import * as React from "react";
import { ErrorIcon, Checkbox, Pane, Text, Dialog, Button, Tooltip, AnnotationIcon, Textarea, toaster, DoubleChevronRightIcon, } from "evergreen-ui";
import { useCart } from "../Cart";
import { BookOrder } from "../Cart";
import { DeleteDialog } from "../Misc/DeleteDialog";
import { EditName } from "../Misc/EditName";
import { useLibrary } from "../Api/Library/Provider";
import { useAPI } from "../Api";
import { findMaterial } from "../Quote/Materials/MaterialFuncs";
import { BookAttachments } from "../Misc/BookAttachments";
// function downloadStringAsFile(filename, str) {
//     const element = document.createElement('a');
//     element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(str));
//     element.setAttribute('download', filename);
//     element.style.display = 'none';
//     document.body.appendChild(element);
//     element.click();
//     document.body.removeChild(element);
// }
export function Book(props) {
    var _a;
    const [isShown, setIsShown] = React.useState(false);
    const [checked, setChecked] = React.useState(false);
    const [hasError, SetHasError] = React.useState(false);
    const textField = React.useRef(null);
    const Library = useLibrary();
    const Cart = useCart();
    const API = useAPI();
    const [savingNotes, setSavingNotes] = React.useState(false);
    const className = checked ? "selected" : "";
    const dxfName = props.book.filename;
    const [attachments, setAttachments] = React.useState([]);
    const [busy, setBusy] = React.useState(false);
    const [disabled, setDisabled] = React.useState(false);
    const MAX_FILE_MSG = "You have uploaded the maximum number of attachments";
    let isReOrder = ((_a = props.book.info) === null || _a === void 0 ? void 0 : _a.selMaterial) ? true : false;
    let TitleEditBox = (React.createElement(EditName, { value: props.book.display, onChange: (nn) => {
            return Library.rename(props.book, nn);
        } }));
    const handleReOrder = (o) => {
        var _a;
        let reOrder = new BookOrder(o);
        reOrder.bends = o.info.bends;
        reOrder.color = o.info.color;
        reOrder.cuts = o.info.cuts;
        reOrder.selMaterial = (_a = o.info) === null || _a === void 0 ? void 0 : _a.selMaterial;
        reOrder.qty = o.info.qty;
        console.log('TODO: check this cuttingLength', o);
        reOrder.cuttingLength = o.info.cuttingLength;
        API.getMaterial(reOrder).then((m) => {
            reOrder.selMaterial = findMaterial(m.Materials, reOrder === null || reOrder === void 0 ? void 0 : reOrder.selMaterial);
            reOrder.RawSetupFee = m.SetupFee;
            Cart.add(reOrder);
            toaster.success("Item Added to Cart");
        });
    };
    return (React.createElement(Pane, { className: className, elevation: 2, width: 300, height: 200, margin: 8, alignItems: "center", justifyContent: "left", display: "flex", flexDirection: "column", borderRadius: "15px", draggable: "true", onDragStart: (e) => {
            e.dataTransfer.setData("book", props.book.key);
        } },
        React.createElement(Button, { className: className, overflowY: "hidden", height: "100%", display: "flex", justifyContent: "center", flex: 1, width: "100%", onClick: (e) => {
                if (e)
                    props.onClick(e);
            }, style: {
                borderRadius: "10px 10px 0px 0px",
                background: props.checked ? "#c6ebff" : "white",
            }, position: "relative", paddingLeft: "25px" },
            React.createElement(Checkbox, { label: "", checked: props.checked, onClick: (e) => {
                    e.stopPropagation();
                }, 
                //setChecked(e.target.checked);
                onChange: (e) => {
                    props.onChecked(e.target.checked);
                    setChecked(props.checked);
                }, position: "absolute", top: "0", left: "0", margin: "5px", padding: "5px", cursor: "default" }),
            props.children,
            !props.children && (React.createElement(Pane, { display: "flex", flexDirection: "row", height: "100%", width: "90%", overflow: "hidden" },
                React.createElement(Pane, { display: "flex", justifyContent: "center", alignItems: "center" },
                    React.createElement("div", { className: "dxfsvf", dangerouslySetInnerHTML: { __html: props.book.svg } })),
                React.createElement(Pane, { display: "flex", justifyContent: "center", alignItems: "center" },
                    React.createElement(Tooltip, { content: props.book.display },
                        React.createElement(Text, null, props.book.display)))))),
        React.createElement(Dialog, { isShown: isShown, onCloseComplete: () => setIsShown(false), hasFooter: false, hasHeader: false, shouldCloseOnOverlayClick: false },
            " ",
            React.createElement(Pane, { display: "flex", justifyContent: "space-between", alignItems: "center" },
                TitleEditBox,
                React.createElement(Button, { appearance: "primary", background: "#206be1", onClick: () => {
                        setIsShown(false);
                    } }, "Close")),
            React.createElement(Pane, { display: "flex", flexDirection: "column" },
                React.createElement(Textarea, { placeholder: "Enter Note", ref: textField, defaultValue: props.book.notes ? props.book.notes : null, marginBottom: "1%" }),
                React.createElement(Button, { isLoading: savingNotes, appearance: "primary", intent: "success", onClick: () => {
                        setSavingNotes(true);
                        Library.updateNotes(props.book, textField.current.value).then(() => {
                            setSavingNotes(false);
                        });
                    } }, "Save")),
            React.createElement(BookAttachments, { book: props.book })),
        React.createElement(Pane, { display: "flex", background: "#206BE1", height: "15%", style: { borderRadius: "0px 0px 10px 10px" }, width: "100%" },
            React.createElement(Pane, { flex: 1, alignItems: "center", display: "flex", padding: 8, onClick: () => {
                    props.onClick();
                } },
                hasError && React.createElement(ErrorIcon, { color: "danger" }),
                React.createElement(Text, { marginLeft: 8, cursor: "pointer", color: "white" }, "Add to cart")),
            React.createElement(Pane, { display: "flex", flexDirection: "row", justifyContent: "flex-end", gap: 16, marginRight: 10, alignItems: "center" },
                React.createElement(DeleteDialog, { color: "red", onDelete: () => {
                        Library.remove(props.book);
                    }, named: "File: " + props.fileName }),
                React.createElement(AnnotationIcon, { cursor: "pointer", color: "white", onClick: () => {
                        setIsShown(true);
                    } }),
                isReOrder && (React.createElement(Tooltip, { content: "Re-Order" },
                    React.createElement(DoubleChevronRightIcon, { size: 20, cursor: "pointer", color: "#82ff84", onClick: () => {
                            handleReOrder(props.book);
                        } })))))));
}
